"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiDialogContentOverrides = function (_a) {
    var _b;
    var breakpoints = _a.breakpoints, spacing = _a.spacing;
    return ({
        root: (_b = {
                padding: spacing(4, 6, 5),
                "&:first-child": {
                    paddingTop: spacing(5),
                }
            },
            _b[breakpoints.up("lg")] = {
                paddingLeft: spacing(8),
                paddingRight: spacing(8),
            },
            _b[breakpoints.up("xl")] = {
                paddingLeft: spacing(13),
                paddingRight: spacing(13),
            },
            _b),
    });
};
//# sourceMappingURL=MuiDialogContent.js.map